import { render, staticRenderFns } from "./ipq-list-page.html?vue&type=template&id=0ae6ca07&"
import script from "./ipq-list-page.ts?vue&type=script&lang=ts&"
export * from "./ipq-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./ipq-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports